import { services } from '@comall-backend-builder/core';
import { ApiRequestConfig } from '@comall-backend-builder/core/lib/services/api';

const api = services.api;

const paramsArrayToString = (filters: any) => {
    const convertedFilters = {};
    Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value && Array.isArray(value)) {
            convertedFilters[key] = value.join(',');
        } else {
            convertedFilters[key] = value;
        }
    });
    return convertedFilters;
};
// 商品资料中心和商品经营管理
export const ProductFindPostLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        const paramData = paramsArrayToString(params);
        config.apiPath = `/products/findPost`;
        return api.post(paramData, config);
    },
    put: async function(params: any, config: ApiRequestConfig) {
        let param = Object.assign({}, params);
        delete param.id;
        config.apiPath = `/products/${params.id}`;
        return api.put(param, config);
    },
};
